import { callExternalApi, CallResult } from '../callExternalApi';
import { AdviseCustomer } from '../../types/advise';
import { getAdviseAccountId, withAdviseAccountIds } from './helpers';

export const fetchAdviseCustomers = async (): Promise<CallResult<AdviseCustomer[]>> =>
  withAdviseAccountIds('customers', (accountIds) =>
    callExternalApi<AdviseCustomer[]>({
      url: `api/advise/customer_profiles?account_ids=${accountIds.join(',')}`,
      method: 'GET',
      headers: { 'content-type': 'application/json' }
    })
  );

export const fetchAdviseCustomerById = async (id: string): Promise<CallResult<AdviseCustomer>> => {
  return callExternalApi<AdviseCustomer>({
    url: `api/advise/customer_profiles/${id}`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const findOrCreateAdviseCustomer = async (
  accountId: string,
  companyName: string
): Promise<CallResult<AdviseCustomer>> => {
  return callExternalApi<AdviseCustomer>(
    {
      url: 'api/advise/customer_profiles/find_or_create',
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      data: { account_id: accountId, company_name: companyName }
    },
    false
  );
};

export const createAdviseCustomer = async (customer: Partial<AdviseCustomer>): Promise<CallResult<AdviseCustomer>> => {
  const accountId = getAdviseAccountId();
  return callExternalApi<AdviseCustomer>({
    url: 'api/advise/customer_profiles',
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    data: { ...customer, account_id: accountId }
  });
};

export const updateAdviseCustomer = async (
  id: string,
  customer: Partial<AdviseCustomer>
): Promise<CallResult<AdviseCustomer>> => {
  return callExternalApi<AdviseCustomer>({
    url: `api/advise/customer_profiles/${id}`,
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    data: customer
  });
};

export const deleteAdviseCustomer = async (id: string): Promise<CallResult<void>> => {
  return callExternalApi<void>({
    url: `api/advise/customer_profiles/${id}`,
    method: 'DELETE',
    headers: { 'content-type': 'application/json' }
  });
};
